import { getLDFlag } from '@/data/LD/selectors/getLDFlag';
import { getAuthAccount, getAuthUser } from '@/shared/auth/selectors';
import Features from '@/shared/features';

import { createSelector } from '@reduxjs/toolkit';

const getAttendance = (user, account) => {
  // Do not show attendance to non-attendance accounts
  if (!account.hasFeature(Features.ATTENDANCE)) {
    return false;
  }

  // Show attendance only to supervisors and above
  return !user.isEmployee();
};

export const hasAttendance = createSelector([getAuthUser, getAuthAccount], getAttendance);

export const hasOnboardedAttendance = createSelector(
  [getAuthAccount, state => getLDFlag(state, 'sat-367-turn-off-attendance')],
  (account, sat367) => {
    return (
      account.hasAttendance() &&
      (account.getSettings('payroll.is_onboarded', false) || (sat367 && account.payroll_date !== false))
    );
  },
);
